import { createAction } from '@reduxjs/toolkit'
import { FiltreCopiesType } from 'store/reducers/FiltreCopiesReducer'

export const resetFiltreCopies = createAction<undefined>('resetFiltreCopies')
export const setFilters = createAction<FiltreCopiesType>('setFilters')
